import { Trans } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Stack } from '@mui/material'
import DevicesRoundedIcon from '@mui/icons-material/DevicesRounded'
import dayjs from 'dayjs'

import { TimeSession } from '@/core/api/time-tracking'

type ConflictSessionDialogProps = {
  session: TimeSession | null
  loading?: boolean
  onContinue: () => void
  onCancel: () => void
}

export function ConflictSessionDialog({ session, loading, onContinue, onCancel }: ConflictSessionDialogProps) {
  useLingui()

  return (
    <Dialog open={!!session} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <DevicesRoundedIcon color="warning" />
          <Typography variant="h6" component="span">
            <Trans>Session active on another device</Trans>
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Typography variant="body2" color="text.secondary">
            <Trans>
              A time-tracking session is already running on another device. Continuing here will close the other session and start a new one on this device.
            </Trans>
          </Typography>
          {session && (
            <Stack sx={{ bgcolor: 'grey.50', p: 2, borderRadius: 1 }}>
              <Typography variant="caption" color="text.secondary">
                <Trans>Session started</Trans>
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {dayjs(session.startTime).format('DD/MM/YYYY HH:mm')}
              </Typography>
            </Stack>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={loading}>
          <Trans>Cancel</Trans>
        </Button>
        <Button onClick={onContinue} variant="contained" color="primary" disabled={loading} autoFocus>
          <Trans>Continue here</Trans>
        </Button>
      </DialogActions>
    </Dialog>
  )
}
